import { defineComponent as _defineComponent } from 'vue';
import { Primitive } from "reka-ui";
import { cn } from '../utils';
import { buttonVariants } from ".";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        variant: { type: null, required: false },
        size: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        as: { type: [String, Object], required: false, default: "button" },
        asChild: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get Primitive() { return Primitive; }, get cn() { return cn; }, get buttonVariants() { return buttonVariants; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
